import { generatePath } from 'react-router-dom'
import { SEO_RELEVANCE_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { FileSearch1 } from 'blaze-ui/icons/24'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuSeoRelevanceItem = ({ workspaceId, onPress }: Props) => {
  return (
    <NavMenuItem
      icon={FileSearch1}
      activeIcon={FileSearch1}
      to={generatePath(SEO_RELEVANCE_PATH, { workspaceId })}
      onPress={onPress}
      label="SEO"
    />
  )
}

export { NavMenuSeoRelevanceItem }
